/**
 * Stock fundamentals utility
 *
 * All data is fetched via /api/fundamentals (Cloudflare Pages Function).
 * The backend handles SEC EDGAR + Yahoo Finance calls with edge caching.
 */

export const STOCKS = [
  { ticker: 'AAPL', name: 'Apple', nameCn: '苹果', cik: '0000320193', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/apple.svg' },
  { ticker: 'NVDA', name: 'NVIDIA', nameCn: '英伟达', cik: '0001045810', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/nvidia.svg' },
  { ticker: 'AMZN', name: 'Amazon', nameCn: '亚马逊', cik: '0001018724', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/amazon.svg' },
  { ticker: 'MSFT', name: 'Microsoft', nameCn: '微软', cik: '0000789019', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/microsoft.svg' },
  { ticker: 'TSLA', name: 'Tesla', nameCn: '特斯拉', cik: '0001318605', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/tesla.svg' },
  { ticker: 'META', name: 'Meta', nameCn: 'Meta', cik: '0001326801', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/meta.svg' },
  { ticker: 'GOOGL', name: 'Alphabet', nameCn: '谷歌', cik: '0001652044', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/google.svg' },
  { ticker: 'JPM', name: 'JPMorgan Chase', nameCn: '摩根大通', cik: '0000019617', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/chase.svg' },
  { ticker: 'V', name: 'Visa', nameCn: 'Visa', cik: '0001403161', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/visa.svg' },
  { ticker: 'MA', name: 'Mastercard', nameCn: '万事达', cik: '0001141391', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/mastercard.svg' },
  { ticker: 'UNH', name: 'UnitedHealth', nameCn: '联合健康', cik: '0000731766', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/unitedhealthgroup.svg' },
  { ticker: 'WMT', name: 'Walmart', nameCn: '沃尔玛', cik: '0000104169', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/walmart.svg' },
  { ticker: 'XOM', name: 'Exxon Mobil', nameCn: '埃克森美孚', cik: '0000034088', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/exxonmobil.svg' },
  { ticker: 'KO', name: 'Coca-Cola', nameCn: '可口可乐', cik: '0000021344', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/cocacola.svg' },
  { ticker: 'BAC', name: 'Bank of America', nameCn: '美国银行', cik: '0000070858', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/bankofamerica.svg' },
  { ticker: 'AXP', name: 'American Express', nameCn: '美国运通', cik: '0000004962', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/americanexpress.svg' },
  { ticker: 'CVX', name: 'Chevron', nameCn: '雪佛龙', cik: '0000093410', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/chevron.svg' },
  { ticker: 'PG', name: 'Procter & Gamble', nameCn: '宝洁', cik: '0000080424', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/proctergamble.svg' },
  { ticker: 'AMD', name: 'AMD', nameCn: 'AMD', cik: '0000002488', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/amd.svg' },
  { ticker: 'NFLX', name: 'Netflix', nameCn: '奈飞', cik: '0001065280', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/netflix.svg' },
];

/**
 * Fetch fundamentals for multiple stocks via backend API.
 * Returns { AAPL: {...}, NVDA: {...}, ... } or {} on failure.
 */
export async function fetchAllStockFundamentals(tickers = STOCKS.map((s) => s.ticker)) {
  try {
    const res = await fetch(`/api/fundamentals?symbols=${encodeURIComponent(tickers.join(','))}`);
    if (!res.ok) return {};
    const payload = await res.json();
    return payload.data || {};
  } catch {
    return {};
  }
}

/**
 * Fetch fundamentals for a single stock via backend API.
 * Returns the stock data object or null on failure.
 */
export async function fetchStockDetail(ticker) {
  try {
    const res = await fetch(`/api/fundamentals?symbols=${encodeURIComponent(ticker)}`);
    if (!res.ok) return null;
    const payload = await res.json();
    return payload.data?.[ticker] || null;
  } catch {
    return null;
  }
}
